import { render, staticRenderFns } from "./onebox-loginbysharetoken.vue?vue&type=template&id=48974674&"
import script from "./onebox-loginbysharetoken.vue?vue&type=script&lang=js&"
export * from "./onebox-loginbysharetoken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports